import { ReactNode } from "react";
import { IconTrash } from "@tabler/icons-react";
import { ContextType, FileType } from "../../../types/File.ts";
import { openModal } from "../../core/PopUp.tsx";
import PopUpDialog from "../../core/PopUpDialog.tsx";
import { deleteFiles } from "../../../fetch/fetch.file.ts";

const ImageDelete = ({
  children,
  context,
  contextId,
  file,
  onFileDelete,
}: {
  children: (handleClick: () => void) => ReactNode;
  context: ContextType;
  contextId: string;
  file: FileType;
  onFileDelete: (file: FileType) => void;
}) => {
  const handleFileDelete = async () => {
    await deleteFiles([file._id], context, contextId);
    onFileDelete(file);
  };

  if (file.local) {
    return null;
  }
  return (
    <>
      {children(() => openModal(`photo-delete-${file.basename}`))}
      <PopUpDialog
        title={
          <>
            <IconTrash /> Foto löschen?
          </>
        }
        id={`photo-delete-${file.basename}`}
        loading={false}
        onClick={handleFileDelete}
        description="Willst du das Foto löschen?"
        className="hidden"
      >
        <IconTrash />
        Foto löschen
      </PopUpDialog>
    </>
  );
};
export default ImageDelete;
